import axios from 'axios'

const BASE_URL = "https://playerzportal.mnrhub.com/pubgt/api/v1";

// "https://us-central1-mnrhub-e4a87.cloudfunctions.net/mnrhub/mnrhub/api/v1/";
const LOCAL_URL = "http://localhost:5000/pubgt/api/v1"


export default axios.create({
    baseURL:BASE_URL,
    headers:{'Content-Type':'application/json'},

});

export const axiosPrivate = axios.create({
    baseURL:BASE_URL,
    headers:{'Content-Type':'application/json'},
    withCredentials:true
});